import Box from "@mui/material/Box";
import * as React from "react";
import { Translations } from "../../../models/translations";
import { ProgressBar } from "../ProgressBar";
import { TBarSerie } from "../../../models/common/barSerie";

export interface IHorizontalBarsProp {
    series: TBarSerie[];
    hideTotal?: boolean;
}

export const HorizontalBars = (props: IHorizontalBarsProp) => {
    const total = props.series.reduce((sum, { amount }) => sum + amount, 0);

    return (
        <Box sx={{
            width: "100%",
            display: "grid",
            gridTemplateColumns: "max-content 1fr max-content",
            alignItems: "center",
            gap: ".75rem 1rem",
        }}>
            {props.series.map(({ title, amount, color, backgroundColor }) => (
                <React.Fragment key={title}>
                    <Box>{title}</Box>
                    <Box>
                        <ProgressBar
                            tooltip={title}
                            value={amount / total * 100}
                            customColor={color ?? "#8fa8df"}
                            customBackColor={backgroundColor ?? "#edf0f4"}
                        />
                    </Box>
                    <Box sx={{ textAlign: "right", fontWeight: "bold" }}>{amount}</Box>
                </React.Fragment>
            ))}
            {!props.hideTotal && (
                <>
                    <Box sx={{ fontWeight: "bold" }}>{Translations.Total}</Box>
                    <Box></Box>
                    <Box sx={{ textAlign: "right", fontWeight: "bold" }}>{total}</Box>
                </>
            )}
        </Box>
    );
};
